import { CardHeader } from 'app/src/features/Catalog/components/CardHeader'
import { Card } from 'primereact/card'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function InformativeBanner(): ReactElement {
  const { t } = useTranslation('catalog')

  return (
    <div className='grid'>
      <Card title={<CardHeader title={t('Catalog.InformativeBanner.Title')} />}>
        <div className='rounded-md bg-[var(--card-background)] p-4'>
          <p className='m-0'>{t('Catalog.InformativeBanner.Text')}</p>
        </div>
      </Card>
    </div>
  )
}
